import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
	const images  = document.querySelectorAll('.lazy-img');
	images.forEach(function(image) { 
		const st = ScrollTrigger.create({
			trigger: image,
			start: "-100% bottom",
			end: "bottom top",
			once: true,
			onEnter: () => {
				loadImage(image);
			},
			// markers: {startColor: "green", endColor: "red", fontSize: "12px"},
		});
	});

	function loadImage(image) {
		const src = image.dataset.src;
		if (src) {
			image.src = src;
		}
		// gsap.to(image, {
		// 	opacity: 1,
		// 	duration: 0.2
		// });
	}
}